import type { ReactNode } from "react";
import styles from "./DescriptionList.module.scss";

const DescriptionTerm = ({ children }: { children: ReactNode }) => {
  return <dt>{children}</dt>;
};

const DescriptionDetails = ({ children }: { children: ReactNode }) => {
  return <dd>{children}</dd>;
};

const DescriptionList = ({ children }: { children: ReactNode }) => {
  return (
    <div className={styles.container}>
      <dl className={styles.descriptionList}>{children}</dl>
    </div>
  );
};

DescriptionList.Term = DescriptionTerm;
DescriptionList.Description = DescriptionDetails;

export { DescriptionList };
